import React from 'react';
import { avatarColor, initials } from '../../utils/format';
type AvatarSize = 'xs' | 'sm' | 'md' | 'lg' | 'xl';
interface AvatarProps {
  name: string;
  seed?: string;
  size?: AvatarSize;
  className?: string;
}
const SIZES: Record<AvatarSize, string> = {
  xs: 'h-6 w-6 text-[10px]',
  sm: 'h-8 w-8 text-xs',
  md: 'h-10 w-10 text-sm',
  lg: 'h-14 w-14 text-lg',
  xl: 'h-24 w-24 text-3xl'
};
export function Avatar({
  name,
  seed,
  size = 'md',
  className = ''
}: AvatarProps) {
  return <span aria-hidden="true" className={`inline-flex shrink-0 select-none items-center justify-center rounded-full font-semibold tracking-wide text-white ${SIZES[size]} ${className}`} style={{
    backgroundColor: avatarColor(seed ?? name)
  }} data-id="element-736" data-mp="1bqe2oev3lrrg">
      {initials(name)}
    </span>;
}